import axios from 'axios';
import { createApiUrl, getToken } from '../../../util';
import api from 'api/axiosInstance';

export async function switchToolTypeToRoof(uuid: string, reqDesignType: DesignType, panelKey: string | undefined, billAmount: number | null) {
	const myToken = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${myToken}`
		}
	};
	const payload:any = {
		uuid,
	};
	if(panelKey) payload['panelKey']= panelKey;
	if(billAmount) payload['billAmount']= billAmount;

	const reqURL = reqDesignType === 'ROOF' ? 'roof/switch-to-roof' : 'switch-to-solar';
	const { data } = await api.patch(createApiUrl(`/designs/${reqURL}/${uuid}`), payload, config);
	return data;
}